import { render, staticRenderFns } from "./DetalhaJogador.vue?vue&type=template&id=36140d17&scoped=true"
import script from "./DetalhaJogador.vue?vue&type=script&lang=js"
export * from "./DetalhaJogador.vue?vue&type=script&lang=js"
import style0 from "./DetalhaJogador.vue?vue&type=style&index=0&id=36140d17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36140d17",
  null
  
)

export default component.exports